module.exports = __webpack_public_path__ + "img/vessel_visitation_1_63021_crop.28294032.jpg";